(function(){
  var productTiles = [
    {
      title: 'Rig Tags',
      path: '/collections/lifting-rigging-inspection-tags',
      image: 'https://cdn.shopify.com/s/files/1/0877/1407/0833/collections/Group_Lifting_Rigging_Inspection_Tags.png?v=1782802210'
    },
    {
      title: 'Safety Tags',
      path: '/collections/safety-tags',
      image: 'https://cdn.shopify.com/s/files/1/0877/1407/0833/collections/Group_Safety_Tags.png?v=1782802381'
    },
    {
      title: 'Rubber Tags',
      path: '/collections/rubber-tag',
      image: 'https://cdn.shopify.com/s/files/1/0877/1407/0833/collections/Group_Rubber_Tags.png?v=1782863599'
    },
    {
      title: 'Scaffold Tags',
      path: '/collections/scaffold-tags',
      image: 'https://cdn.shopify.com/s/files/1/0877/1407/0833/collections/Group_Scaffold.png?v=1782802531'
    },
    {
      title: 'Lockout Tagout',
      path: '/collections/lockout-tagout',
      image: 'https://cdn.shopify.com/s/files/1/0877/1407/0833/collections/LoToPro_Collection_Photo_c96013af-6e39-4cc7-afd9-a98566aa2b7a.webp?v=1791252879'
    },
    {
      title: 'Lockout Kits',
      path: '/collections/lockout-kits',
      image: 'https://cdn.shopify.com/s/files/1/0877/1407/0833/collections/ALK08.jpg?v=1782286708'
    }
  ];

  function buildProductsGrid(productsLi){
    var dropdown = productsLi.querySelector(':scope > ul');
    if(!dropdown) return;

    var shell = dropdown.querySelector(':scope > .archford-products-grid-shell');
    if(shell && shell.dataset.archfordReady === '1') return;

    if(!shell){
      shell = document.createElement('li');
      shell.className = 'archford-products-grid-shell';
      dropdown.appendChild(shell);
    }

    shell.innerHTML = '';
    var grid = document.createElement('div');
    grid.className = 'archford-products-grid';

    productTiles.forEach(function(tile){
      var link = document.createElement('a');
      link.href = tile.path;
      link.setAttribute('aria-label', tile.title);

      var imageWrap = document.createElement('span');
      imageWrap.className = 'archford-product-tile-image';
      imageWrap.setAttribute('aria-hidden','true');

      var image = document.createElement('img');
      image.src = tile.image;
      image.alt = '';
      image.width = 256;
      image.height = 256;
      image.loading = 'eager';
      image.decoding = 'async';
      imageWrap.appendChild(image);

      var title = document.createElement('span');
      title.className = 'archford-products-grid-title';
      title.textContent = tile.title;

      link.appendChild(imageWrap);
      link.appendChild(title);
      grid.appendChild(link);
    });

    shell.appendChild(grid);
    shell.dataset.archfordReady = '1';
  }

  function protectProductsNav(){
    document.querySelectorAll('#nav, #nav-bar').forEach(function(nav){
      var menu = nav.querySelector('ul[data-type]');
      if(!menu) return;

      var productsLink = null;
      Array.from(menu.children).some(function(li){
        var a = li.querySelector(':scope > a[href="/collections/all"]');
        if(a){ productsLink = a; return true; }
        return false;
      });
      if(!productsLink) return;

      var productsLi = productsLink.parentElement;
      productsLi.classList.add('archford-products-protected');
      productsLi.classList.remove('temp-hidden');

      var firstReal = Array.from(menu.children).find(function(li){
        return !li.classList.contains('show-all');
      });
      if(firstReal && firstReal !== productsLi) menu.insertBefore(productsLi, firstReal);

      menu.querySelectorAll('.show-all-submenu a[href="/collections/all"]').forEach(function(a){
        var li = a.closest('li');
        if(li) li.remove();
      });

      buildProductsGrid(productsLi);
    });
  }

  var queued = false;
  function queueProtect(){
    if(queued) return;
    queued = true;
    requestAnimationFrame(function(){
      queued = false;
      protectProductsNav();
    });
  }

  function init(){
    protectProductsNav();
    document.querySelectorAll('#nav, #nav-bar').forEach(function(nav){
      new MutationObserver(queueProtect).observe(nav,{
        childList:true,
        subtree:true,
        attributes:true,
        attributeFilter:['class']
      });
    });
    window.addEventListener('resize',function(){
      setTimeout(queueProtect,0);
      setTimeout(queueProtect,300);
    });
    document.addEventListener('shopify:section:load',queueProtect);
    document.addEventListener('shopify:section:reorder',queueProtect);
    setTimeout(queueProtect,300);
    setTimeout(queueProtect,900);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded',init);
  }else{
    init();
  }
})();